import { FormProvider } from "services/dealer-contact-form/context";
import { InformationContent } from "components/information-lister-pages/InformationContent";
import { AutoLayout } from "layouts/AutoLayout";
import { autocoachActieSearchFilters } from "config/autocoachSettings";
import React, { ReactElement } from "react";
import { getFiltersWithModels, withFiltersFromProps } from "services/filter";
import {
    extractFiltersAndParamsFromPath,
    getListingsWithCounters,
    withSearchFromProps
} from "services/search";
import { withPreviewFromProps } from "components/Preview";
import { getContentfulEntries } from "services/contentful/client/contentfulClient";
import { getContentfulFields } from "lib/contentful";
import { NextPage, NextPageContext } from "next";
import { reroute } from "helpers/reroute";

type Props = {
    content?: Record<string, any>;
    searchParams?: any;
    searchFilters?: Record<string, any>;
    results?: any;
    counts?: number;
    filters: Record<string, any>;
};

export const DynamicPage: NextPage<Props | void> = withPreviewFromProps(
    withFiltersFromProps(
        withSearchFromProps((props: Props): ReactElement | null => {
            const { content } = props;

            if (!content) return null;

            return (
                <AutoLayout
                    title={content?.titleSeo || content?.type}
                    description={content?.metaDescriptionSeo || content?.type}
                    pageName="home"
                    path={content.path}
                    pageType="pageNotFound"
                >
                    <FormProvider>
                        <InformationContent content={content} results={null} />
                    </FormProvider>
                </AutoLayout>
            );
        })
    )
);

DynamicPage.getInitialProps = async ({
    asPath,
    query,
    res
}: NextPageContext): Promise<Props | void> => {
    const path = asPath?.split("?").shift();

    const params = {
        "contentType": "dynamicInformationPage",
        "fields.path": path,
        "include": 3
    };

    const content = await getContentfulEntries(params).then(
        (data) => data && getContentfulFields(data)
    );

    if (!content) {
        const slug = query.slugs;

        reroute(res, slug);
    }

    const url = content?.url;

    const { searchFilters, searchParams } =
        path === "/kopen/kopen-op-afstand"
            ? {
                  searchParams: { pageSize: 8 },
                  searchFilters: autocoachActieSearchFilters
              }
            : {
                  ...extractFiltersAndParamsFromPath(url),
                  searchParams: { pageSize: 8 }
              };

    // warm up the cache of default search
    // @ts-ignore
    const { results, counts } = await getListingsWithCounters(searchFilters, searchParams).then(
        ({ total, hits, aggregations }) => ({
            results: { hits },
            counts: { ...aggregations, total }
        })
    );

    const filters = await getFiltersWithModels();

    return { content: content?.fields, searchParams, searchFilters, results, counts, filters };
};

DynamicPage.displayName = "dynamic-page";

export default DynamicPage;
